export enum Env {
    Staging,
    Localhost,
    Test,
    Production,
}
